import { CaseInsensitiveMap } from "../../../../../Global/Base/DataTypes/CaseInsensitiveMap";
import { IFilterFieldInfo, IFilterJsonData, IFilterJsonResultValue } from "./FilterInterfaces";
import { logger } from "./logger";
/**
 * Mapuje uživatelsky zadaný filtr na interní filtr
 */
export class FilterDatetypeOperationMapper {
    private static _datetypeOpMappings: CaseInsensitiveMap<IFilterFieldInfo[]> = new CaseInsensitiveMap<IFilterFieldInfo[]>();

    public static register(dataType: string, operation: string, valuesDefinition: IFilterFieldInfo[]): void {
        const key = `${dataType.toLocaleLowerCase()}:${operation.toLocaleLowerCase()}`;
        if (FilterDatetypeOperationMapper._datetypeOpMappings.has(key)) {
            logger.log(`There is already definition for datetype '${dataType}' and operation '${operation}'`);
            return;
        }
        FilterDatetypeOperationMapper._datetypeOpMappings.set(key, valuesDefinition);
    }

    public static transformUserJson(json: string, columnDataTypes: CaseInsensitiveMap<{ dataType: string; locKey: string }>): IFilterJsonData {
        const filter: IFilterJsonData = JSON.parse(json);
        for (const attr of filter.attrs) {
            if (attr.operator === undefined) attr.operator = "and";
            if (attr.enabled === undefined) attr.enabled = true;
            for (const cond of attr.conditions) {
                if (cond.operator === undefined) cond.operator = "or";
                if (cond.enabled === undefined) cond.enabled = true;
                if (cond.isValid === undefined) cond.isValid = true;
                if (cond.isMultiItem === undefined) cond.isMultiItem = false;
                const dataType = columnDataTypes.get(attr.attrName).dataType;
                const key = `${dataType.toLocaleLowerCase()}:${cond.operation.toLocaleLowerCase()}`;
                if (!FilterDatetypeOperationMapper._datetypeOpMappings.has(key)) {
                    continue;
                }
                const def = FilterDatetypeOperationMapper._datetypeOpMappings.get(key);

                //projdou se všechny hodnoty a doplní se mapování chybějících atributů
                if (def.length !== cond.values.length) {
                    logger.error(`Cannot proceed with tranformation for column '${attr.attrName}'  and operation '${cond.operation}'`);
                    continue;
                }
                for (let i = 0; i < cond.values.length; i++) {
                    //hodnota může být jako single string, v tom případě ji potřebujeme vrátit jako objekt
                    if (typeof cond.values[i] === "string" || Array.isArray(cond.values[i]))
                        cond.values[i] = { value: cond.values[i] } as IFilterJsonResultValue;
                    if (def[i].fromJsonFormatter)
                        cond.values[i].value = def[i].fromJsonFormatter(cond.values[i].value);
                    cond.values[i].fieldId = def[i].id;
                    cond.values[i].fieldType = def[i].fieldType;
                }
            }
        }
        return filter;
    }
}
